export default (params) => {
  const {
    title,
    updateUserPreferences,
    userPreferences,
    sectionKey,
    formatType,
  } = params;

  const {
    leftPane: {
      activeElement: { index: updateSectionIndex },
      used,
    },
  } = userPreferences;

  const updatedUsedSections = used.map((usedSection, index) => {
    if (index === updateSectionIndex) {
      return { ...usedSection, title, sectionKey };
    }
    return usedSection;
  });
  const updatedUserPreferences = {
    ...userPreferences,
    leftPane: {
      ...userPreferences.leftPane,
      activeElement: {
        ...userPreferences.leftPane.activeElement,
        title,
        sectionKey,
      },
      used: updatedUsedSections,
    },
  };

  updateUserPreferences({
    userPreferences: { ...updatedUserPreferences },
    formatType,
  });
};
